import Footer from './Footer';
import Formulario from './Formulario'
const Home = () => {
    return (
        <>
         <div className='stricky text-center'><a href='https://fb.watch/mNMSH39fdn/' target='_blank' className='link text-light '>Ver transmisión en vivo aquí</a></div>
            <div className="text-center bg-Home">
                <div className='container'>
                   
                    <div className="row justify-content-center">
                        <div className="col-12">
                            <img src={process.env.PUBLIC_URL + "/images/Final_Logo.png"} className='logoHome mb-5' />
                        </div>
                        <div className="contenedor col-12">
                            <p className='titulo fw-normal mb-3'>LA BODA MÁS <strong className='titulosA'>ESPECTACULAR</strong> DEL AÑO PUEDE SER <strong className='titulosA'>TUYA.</strong></p>
                            <p className='titulo2 fw-light mb-5'>CUÉNTANOS SU HISTORIA DE <strong className='titulosA'>AMOR</strong> Y <strong className='titulosA'>NOSOTROS</strong> PONEMOS EL RESTO.</p>
                            {/*<button type="button" className="btn btn-registro" data-bs-toggle="modal" data-bs-target="#exampleModal">
                                REGÍSTRATE AQUÍ </button>*/}
                            <div className="modal fade" id="exampleModal" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                                <div className="modal-dialog  modal-dialog-centered">
                                    <div className="modal-content">
                                        <div className="modal-header">
                                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                                        </div>
                                        <div className="modal-body">
                                            <Formulario />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <h5 className="titulo2 text-center mt-4 mb-4">DGRTC/0889/2023</h5>
                        <div className='container p-5'>
                            <div className='row'>
                                <div className='col-12'>
                                    <h5 className='letter-space'>PATROCINADO POR:</h5>
                                </div>
                                <div className='mx-auto col-md-4 mb-2'>
                                    <a href='https://www.visitcostarica.com/es/mexico' target='_blank'><img className='costa' src={process.env.PUBLIC_URL + "/images/1- LOGO COSTA RICA.png"} /></a>
                                </div>
                                <div className='mx-auto col-md-4 mb-3'>
                                    <a href='https://mesaderegalos.liverpool.com.mx' target='_blank'><img className='mesas' src={process.env.PUBLIC_URL + "/images/logo_mesa.png"} /></a>
                                </div>
                                <div className='mx-auto col-md-4 mb-3'>
                                    <a href='https://www.cts.com.mx' target='_blank'><img className='CTS' src={process.env.PUBLIC_URL + "/images/logo_cst.png"} /></a>
                                </div>
                            </div>
                            <div className='row'>
                                <div className='mx-auto col-md-4 mb-2'>
                                    <a href='https://www.liverpool.com.mx/tienda/home' target='_blank'><img className='liverpool' src={process.env.PUBLIC_URL + "/images/logo_Liverpool.png"} /></a>
                                </div>
                                <div className='mx-auto col-md-4 mb-2'>
                                    <a href='https://sposabella.mx/' target='_blank'><img className='liverpool' src={process.env.PUBLIC_URL + "/images/logo_Sposa.png"} /></a>
                                </div>
                                <div className='mx-auto col-md-4 mb-2 mt-3'>
                                    <a href='https://socasesores.com/' target='_blank'><img className='soc' src={process.env.PUBLIC_URL + "/images/logos/Logo_Soc.png"} /></a>
                                </div>
                            </div>
                            <div className='row'>
                                <div className='mx-auto col-md-4 mb-2'>
                                    <a href='https://mauriciorenteria.com' target='_blank'><img className='liverpool' src={process.env.PUBLIC_URL + "/images/logos/MAURICIO RENTERIA LOGO.png"} /></a>
                                </div>
                                <div className='mx-auto col-md-4 mb-2'>
                                    <a href='https://www.recordartefilms.com' target='_blank'><img className='liverpool' src={process.env.PUBLIC_URL + "/images/logos/RECORDARTE FILMS LOGO.png"} /></a>
                                </div>
                                <div className='mx-auto col-md-4 mb-2'>
                                    <a href='https://www.silviagalvan.com' target='_blank'><img className='liverpool m-3' src={process.env.PUBLIC_URL + "/images/logos/Silvia Galvan Image Studio Logo.png"} /></a>
                                </div>
                            </div>
                            <div className='row'>
                                <div className='mx-auto col-md-4 mb-2'>
                                    <a href='https://jdjoyeros.com' target='_blank'><img className='joyeros' src={process.env.PUBLIC_URL + "/images/logos/JD JOYEROS LOGO2_0_5x.png"} /></a>
                                </div>
                                <div className='mx-auto col-md-4 mb-2'>
                                    <a href='https://sacher.com.mx' target='_blank'><img className='joyeros' src={process.env.PUBLIC_URL + "/images/logos/L´AUTRICHIENNE LOGO_0_5x.png"} /></a>
                                </div>
                                <div className='mx-auto col-md-4 mb-2'>
                                    <a href='https://floresmeyer.com.mx' target='_blank'><img className='Floresmeyer' src={process.env.PUBLIC_URL + "/images/logos/Floresmeyer.png"} /></a>
                                </div>
                            </div>
                            <div className='row'>
                                <div className='mx-auto col-md-4 mb-2'>
                                    <a href='https://www.loreal-paris.com.mx' target='_blank'><img className='loreal' src={process.env.PUBLIC_URL + "/images/logos/LOGO_LOREAL.png"} /></a>
                                </div>
                                <div className='mx-auto col-md-4 mb-2'>
                                    <a href='https://chefman.com.mx/' target='_blank'><img className='loreal' src={process.env.PUBLIC_URL + "/images/logos/LOGO_CHEFMAN.png"} /></a>
                                </div>
                                <div className='mx-auto col-md-4 mb-2 text-center'>
                                    <a href='https://tienda.prudence.com.mx/' target='_blank'><img className='prudence' src={process.env.PUBLIC_URL + "/images/logos/Logo_P.png"} /></a>
                                </div>
                            </div>
                            <div className='row'>
                                <div className='mx-auto col-md-4 mb-2'>
                                    <a href='https://www.yakult.com.mx' target='_blank'><img className='loreal' src={process.env.PUBLIC_URL + "/images/logos/logo_Yakult.png"} /></a>
                                </div>
                                <div className='mx-auto col-md-4 mt-3 text-center '>
                                    <a href='https://www.dpaul.mx' target='_blank'><img className='liverpool m-3' src={process.env.PUBLIC_URL + "/images/logos/D PAUL LOGO.png"} /></a>
                                </div>
                                <div className='mx-auto col-md-4 mt-3 text-center '>
                                    <a href='https://www.comex.com.mx/' target='_blank'><img className='liverpool m-3' src={process.env.PUBLIC_URL + "/images/logos/Logo Comex.png"} /></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
}
export default Home;